/**
 * Fixed replies support staff can drop into a ticket reply with one click,
 * shown beside the AI-suggested replies. Picking one replaces the reply box;
 * it never changes the ticket's status. Add a template by appending here.
 */
export interface SupportReplyTemplate {
  id: string;
  label: string;
  body: string;
}

export const SUPPORT_REPLY_TEMPLATES: readonly SupportReplyTemplate[] = [
  {
    id: 'gm-or-corporate',
    label: 'GM / Corporate',
    body:
      'Hello! This request is handled by either your General Manager or the Corporate Office. ' +
      'Please ask your GM or use the Next Health Support Hub to request help. Thank you.',
  },
  {
    id: 'closing-no-reply',
    label: 'Closing – no reply',
    body:
      'Hello! Since we did not hear back, we are closing this ticket for now. ' +
      'Please update this ticket or open a new one if we can help with anything further.',
  },
];
